export const COLUMNS = [
  {
    Header: `Buyer/Seller`,
    accessor: "buyer_seller",
  },
  {
    Header: "Date",
    accessor: "date",
  },
  // {
  //   Header: "Currency",
  //   accessor: "currency",
  // },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Rate",
    accessor: "rate",
  },

  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];
